import React from "react";

export const PoliticaCookies = () => {
  return (
    <section className="page-sectionWhite text-white mb-0 text-center">
            {/*<!-- Imagen nosotros-->*/}
            <div className="container px-2">
                <div className="row row-nosotros">
                    {/*<!-- nosotros Descripcion -->*/}
                    <div className="legales">
                        <div>
                            <h4 className="px-2 text-danger text-uppercase text-center">
                                <strong>Política de cookies</strong>
                            </h4>
                            <p className="text-black">
                                <strong>TRT PRODUCCIONES S.L.</strong> (en adelante “<strong>TRT PRODUCCIONES</strong>”) informa, en cumplimiento con lo dispuesto en el artículo 22.2 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico, que necesita implantar cookies para ofrecer su contenido en la web, así como prestar un mejor servicio a sus usuarios.
                                <br></br>
                            </p>
                            <h6 className="text-black">
                                QUÉ SON LAS COOKIES{" "}
                            </h6>
                            <p className="text-black">
                                Una cookie es un fichero que se descarga en su ordenador al acceder a determinadas páginas web. Las cookies permiten a una página web almacenar y recuperar información sobre los hábitos de navegación de un usuario o de su equipo y, dependiendo de la información que contengan y de la forma en que utilice su equipo, pueden utilizarse para reconocer al usuario.
                            </p>
                            <p className="text-black">
                                La ley vigente permite que almacenemos cookies en su dispositivo, si estas son estrictamente necesarias para el funcionamiento de nuestra plataforma en base al interés legítimo de <strong>TRT PRODUCCIONES</strong>. Así, para el resto de cookies necesitamos su consentimiento, por lo que a continuación le informamos de los diferentes tipos de cookies que utilizamos en nuestra plataforma. 
                            </p>
                            <p className="text-black">
                                Según su finalidad:
                            </p>
                            <ul className="text-black list">
                                <li>
                                    <strong>Cookies técnicas o necesarias</strong>: aquellas estrictamente necesarias para la correcta funcionalidad de la plataforma de TRT PRODUCCIONES. No pueden desactivarse, ya que sin ellas, ciertas partes de la web pueden no estar disponibles.
                                </li>
                                <li>
                                    <strong>Cookies de preferencias o personalización</strong>: permiten recordar información que cambia el aspecto o comportamiento del sitio web según las configuraciones del usuario, como el idioma, modo de visualizar los productos o adaptar la web al tipo de navegador a través del cual se accede.                                
                                </li>
                                <li>
                                    <strong>Cookies de análisis y estadísticas</strong>: ayudan a comprender cómo interactúan los usuarios con la plataforma, reuniendo y proporcionando información de forma anónima como, por ejemplo, las visitas y vistas en la plataforma. Además, permiten identificar problemas técnicos y encontrar la forma de optimizarlo.                                
                                </li>
                                <li>
                                    <strong>Cookies de marketing</strong>: se utilizan para personalizar la plataforma de TRT PRODUCCIONES, mostrando recomendaciones personalizadas de productos o información al usuario en este u otros sitios web. 
                                </li>
                            </ul>
                            <p className="text-black">
                                Según el tiempo que permanecen activadas:
                            </p>
                            <ul className="text-black list">
                                <li>
                                    <strong>Cookies de sesión</strong>: aquellas que guardan exclusivamente información del usuario durante el tiempo que dura su visita a nuestra plataforma.
                                </li>
                                <li>
                                    <strong>Cookies persistentes</strong>: aquellas que retienen información de usuarios que acceden repetidas veces a nuestra plataforma, recordando las preferencias seleccionadas durante un periodo de tiempo definido.
                                </li>
                            </ul>
                            <p className="text-black">
                                Según la entidad que las gestiona:
                            </p>
                            <ul className="text-black list">
                                <li>
                                    <strong>Cookies propias</strong>: aquellas enviadas al terminal del usuario desde un dominio de la plataforma gestionada por TRT PRODUCCIONES y al que el usuario accede y solicita su servicio.
                                </li>
                                <li>
                                    <strong>Cookies de terceros</strong>: aquellas enviadas al equipo del usuario desde un dominio externo y no gestionado por TRT PRODUCCIONES (como Google, YouTube o Twitter).
                                </li>
                            </ul>
                            <p className="text-black">
                                Si desea obtener más información sobre quiénes somos, cómo puede contactarnos y cómo tratamos sus datos personales, consulte nuestra Política de Privacidad.
                            </p>
                            <p className="text-black">
                                Para cualquier duda o aclaración, los usuarios pueden ponerse en contacto con info@trtproducciones.com. 
                            </p>
                            <h6 className="text-black">
                                LISTA DE COOKIES QUE UTILIZAMOS
                            </h6>
                            <p className="text-black">
                                En la tabla a continuación se recoge un listado de las cookies utilizadas en la presente plataforma de TRT PRODUCCIONES:
                            </p>
                            <h6 className="text-black">
                                Cookies Necesarias
                            </h6>
                            <p className="text-black">
                            <table class="default">
                                <tr>
                                    <th className="border p-1">Nombre</th>
                                    <th className="border p-1">Proveedor</th>
                                    <th className="border p-1">Tipo</th>
                                    <th className="border p-1">Caducidad</th>
                                </tr>
                                <tr>
                                    <td className="border p-1">PHPSESSID</td>
                                    <td className="border p-1">TRTPRODUCCIONES.COM</td>
                                    <td className="border p-1">HTTP</td>
                                    <td className="border p-1">Sesión</td>
                                </tr>
                            </table>
                            </p>
                            <h6 className="text-black">
                                Cookies Estadísticas
                            </h6>
                            <p className="text-black">
                            <table class="default">
                                <tr>
                                    <th className="border p-1">Nombre</th>
                                    <th className="border p-1">Proveedor</th>
                                    <th className="border p-1">Tipo</th>
                                    <th className="border p-1">Caducidad</th>
                                </tr>
                                <tr>
                                    <td className="border p-1">vuid</td>
                                    <td className="border p-1">vimeo.com</td>
                                    <td className="border p-1">HTTP</td>
                                    <td className="border p-1">2 años</td>
                                </tr>
                            </table>
                            </p>
                            <h6 className="text-black">
                                Cookies Marketing
                            </h6>
                            <p className="text-black">
                            <table border="1"  class="default">
                                    <tr>
                                        <th className="border p-1">Nombre</th>
                                        <th className="border p-1">Proveedor</th>
                                        <th className="border p-1">Tipo</th>
                                        <th className="border p-1">Caducidad</th>
                                    </tr>
                                    <tr>
                                        <td className="border p-1">WIDGET::local::assignments </td>
                                        <td className="border p-1">soundcloud.com</td>
                                        <td className="border p-1">HTTP</td>
                                        <td className="border p-1">Persistente</td>
                                    </tr>
                            </table>
                            </p>
                            <h6 className="text-black">
                                MODIFICACIÓN DE LA POLÍTICA DE COOKIES
                            </h6>
                            <p className="text-black">
                                <strong>TRT PRODUCCIONES S.L.</strong> se reserva el derecho a modificar la presente Política de Cookies, siempre de acuerdo con los términos permitidos por la legislación española vigente y con la correspondiente comunicación a los usuarios, mediante la publicación en esta plataforma o por cualquier otro medio de comunicación o difusión que se considere oportuno. 
                            </p>
                            <p className="text-black">
                                Fecha de actualización: ENERO 2022.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
  );
};

export default PoliticaCookies;
